import { useQuery } from "@tanstack/react-query";
import { filaPizzasService } from "../services/filaPizzasService";

export const useFilaEstatisticas = (lojaId?: number | null) => {
  const filaLojaKey = lojaId ?? "todas";
  const todasLojasFila = lojaId == null;

  return useQuery({
    queryKey: ["fila-estatisticas", filaLojaKey],
    queryFn: () =>
      filaPizzasService.getEstatisticas({
        ...(todasLojasFila
          ? { todasLojas: true }
          : { lojaId: lojaId ?? undefined }),
      }),
  });
};
